import { projectStore } from '../storage/storage';
import { ITrigger } from '../entities/ITrigger';

/**
 * 创建触发器处理器
 * @param createDefaultTrigger 创建默认触发器的函数（V2 格式）
 * @returns onSelect 处理函数
 */
export function createTriggerHandler(
  createDefaultTrigger: () => any
) {
  return function onSelect({query}: {query: any}) {
    // 1. 从 Store 中通过 ULID 查找 TriggerGroup
    const triggerGroup = projectStore.triggerGroupMap?.[query.triggerGroupUlid];
    if (!triggerGroup) {
      throw new Error(`TriggerGroup not found: ${query.triggerGroupUlid}`);
    }

    // 2. 创建默认触发器（V2 格式）
    const trigger = createDefaultTrigger() as ITrigger;

    // 3. 修改：只维护children（存储完整对象），list由后端维护
    if (!triggerGroup.children) {
      triggerGroup.children = [];
    }
    triggerGroup.children.push(trigger);

    // 4. 注册到 Store（供后续查找使用）
    projectStore.triggerMap[trigger.ulid] = trigger;

    // 6. 返回编辑页面
    window.history.back();
  };
}
